import { render } from "./LeavePeriod.vue?vue&type=template&id=b2e37d60&scoped=true"
import script from "./LeavePeriod.vue?vue&type=script&lang=js"
export * from "./LeavePeriod.vue?vue&type=script&lang=js"

import "./LeavePeriod.vue?vue&type=style&index=0&id=b2e37d60&lang=scss&scoped=true"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e37d60"]])

export default __exports__